import classNames from "classnames";
import React from "react";
import BellSnoozeIcon from "@fidget/common/assets/BellSnoozeIcon.svg";
import styles from "./snoozeIcon.css";

interface Props extends React.HTMLProps<HTMLDivElement> {
  hoverable?: boolean;
}
export const SnoozeIcon = ({ hoverable, ...props }: Props) => {
  return (
    <div {...props} className={classNames(styles.container, { [styles.hoverable]: hoverable })}>
      <img src={BellSnoozeIcon} />
    </div>
  );
};
